import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class GhostSystemStatusService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  saveGhostStatus(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    if (!data?.rowData || data.rowData[data.col_id] === data?.oldRowData?.[data.col_id]) {
      return of({ callSuccess: '1', skipped: true });
    }
    const colId = data.col_id;
    if (!['SCENARIO_STATUS', 'CLIENT_NAME', 'COLLECTION_SIZE_DETAILS'].includes(colId)) {
      if (data.rowData[colId] !== 'Y' && data.rowData[colId] !== 'N') {
        return of({ callSuccess: '0', errorMessage: 'Value can be only Y or N' });
      }
    }
    const params = _.merge({}, globalService?.globalParams || globalService || {}, {
      filing_key: data.rowData.FILING_GROUP,
      column_value: data.rowData[data.colData.map],
      column_name: data.colData.map,
      tax_year: data.rowData.TAX_YEAR,
      scenario: data.rowData.SCENARIO
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=5l44op`,
      params,
      globalService,
      filterParams
    );
  }
}
